import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import debounce from 'lodash.debounce';

import { Button, Separator, Text } from '@cuemath/comps';

import { post as createDemoSlot } from 'actions/demo-slots-create';
import { getAll as getTeacherList } from 'actions/teacher-list';
import { get as getAllStudentCourses } from 'actions/student-courses';
import { invalidateItem as invalidateStudentSlots } from 'actions/student-slots';
import { BATCHES_CONFIG, USER_CONFIG } from 'constants/api';
import { dateObjToEpoch, timeStringToEpoch } from 'utils';
import { Field, Label, SelectInput } from 'modules/form/index';
import { TEACHERS_PER_PAGE } from 'constants/list';
import { studentCourseField } from 'constants/form';

import { EVENT_TYPE } from 'constants/logger';
import { trackEvent } from 'modules/analytics';
import {
  ButtonWrapper,
  FieldWrapper,
  Footer,
  FormWrapper,
  getOptions,
  Head,
  Message,
  renderFormField,
} from 'modules/form';

import {
  demoAutomationFields,
  FIELD_TYPES,
  FORM_ACTIONS,
  getInputChangeMethod,
  getOnChangeMethod,
  USER_TAB,
} from 'constants/form';
import { OPTIONS } from '../constants/form';

const getFormDefaults = () => {
  const formDefaults = {};

  demoAutomationFields.forEach(field => {
    formDefaults[field.name] = field.default;
  });
  formDefaults['studentCourse'] = null;
  return formDefaults;
};

class CreateDemoSlot extends PureComponent {
  static defaultProps = {
    studentId: null,
    trainingTeachers: false,
  };

  static propTypes = {
    actions: PropTypes.shape({
      createDemoSlot: PropTypes.func.isRequired,
      getTeacherList: PropTypes.func.isRequired,
      invalidateStudentSlots: PropTypes.func.isRequired,
      getAllStudentCourses: PropTypes.func.isRequired,
    }).isRequired,
    studentId: PropTypes.string.isRequired,
    userConfig: PropTypes.object.isRequired,
    batchConfig: PropTypes.object.isRequired,
    trainingTeachers: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isValid: true,
      errorText: null,
      slotPost: store.post(),
      teachersData: null,
      message: null,
      tab: USER_TAB.SLOT,
      type: FORM_ACTIONS.CREATE,
      form: getFormDefaults(),
      formFields: this.getFormFields(),
      teacher_id: null,
      studentCourses: null,
      teacherSearchKey: null,
    };
    demoAutomationFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  componentDidMount() {
    const { actions, studentId } = this.props;

    actions.getAllStudentCourses(studentId);
  }

  onTextChange = (val, reason) => {
    const { action } = reason;
    const { actions, trainingTeachers } = this.props;
    const { errorText } = this.state;
    const listParams = { page: 1, per_page: TEACHERS_PER_PAGE, search: val };
    const filterData = {
      page: 1,
      per_page: TEACHERS_PER_PAGE,
      state: trainingTeachers ? ['ACT', 'INTR', 'FDTR'] : ['ACT', 'FDTR'],
      search: val,
    };

    if (val.length <= 4 && action !== 'menu-close') {
      this.setState({ errorText: 'Please enter more than 4 characters' });
      return;
    }
    if (errorText) {
      this.setState({ errorText: null });
    }

    if (action !== 'menu-close' || val.length !== 0) {
      this.setState({ teacherSearchKey: val }, () => {
        actions.getTeacherList(listParams, filterData);
      });
    }
  };

  getFormFields = () => {
    const { userConfig, batchConfig } = this.props;

    return demoAutomationFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT) {
        const updatedBatchConfig =
          batchConfig && field.name === OPTIONS.SLOT_TAG
            ? {
                ...batchConfig,
                slot_tags: batchConfig.slot_tags?.filter(
                  tag => tag === 'TEACHER_TRAINING' || tag === 'TEST',
                ),
              }
            : batchConfig;

        field.choices = getOptions({
          field: field.name,
          userConfig,
          batchConfig: updatedBatchConfig,
        });
      }
      return field;
    });
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { demoSlots, teacherList, studentId, actions, studentCourses } = props;
    const { slotPost, page, formFields, form, teacherSearchKey } = state;
    const newSlotPost = store.post(demoSlots, slotPost.id);
    const listParams = { page, per_page: TEACHERS_PER_PAGE, search: teacherSearchKey };
    const studentCourseGet = store.get(studentCourses, studentId);

    if (newSlotPost.resolved) {
      if (newSlotPost.resolved.isCreated) {
        newState.SlotPost = newSlotPost;
        newState.message = 'slot created successfully';
        actions.invalidateStudentSlots(studentId);
      } else if (newSlotPost.resolved.isCreatingFailed) {
        newState.SlotPost = newSlotPost;
        newState.errorText = store.getError(newSlotPost.resolved).message;
      }
    }
    if (studentCourseGet && studentCourseGet.isLoaded) {
      const studentCourseData = studentCourseGet.data;
      const { slotTag } = form;
      let studentCourseOptions = [];
      newState.studentCourses = studentCourseData;

      if (studentCourseData && studentCourseData.length > 0) {
        newState.formFields = formFields.filter(function(item) {
          return item.name !== 'studentCourse';
        });

        const isTestClass = slotTag === 'TEST';

        if (isTestClass) {
          studentCourseOptions = studentCourseData.filter(
            ({ access_type: accessType }) => accessType === 'WITH_TEACHER',
          );

          studentCourseField.choices = getOptions({
            field: 'studentCourse',
            studentCourseOptions,
          });

          if (studentCourseOptions.length === 1) {
            form['studentCourse'] = studentCourseOptions[0]['id'];
            studentCourseField.default = studentCourseOptions[0]['course_name'];
            newState.form = form;
          }

          if (studentCourseOptions.length) {
            newState.formFields.splice(2, 0, studentCourseField);
          }
        }
      }
      newState.studentCourseOptions = studentCourseOptions;
    }
    newState.teachersData = store.getAll(teacherList, listParams);

    return newState;
  }

  onChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };

    newForm[key] = value;

    if (key === 'startDate') {
      newForm.endDate = newForm[key];
      newForm.day = String(new Date(newForm[key]).getDay());
      if (newForm.day === '0') newForm.day = '7';
    }
    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onTeacherSelect = selectedTeacher => {
    const { errorText } = this.state;
    const teacherId = selectedTeacher.value;
    const stateChanges = { teacher_id: teacherId };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onToggle = event => {
    const { form, errorText } = this.state;
    const key = event.target.name;
    const value = event.target.checked;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;

    const newForm = { ...form };

    newForm[key] = value;
    const stateChanges = {};

    if (key === 'slotTag') {
      newForm['studentCourse'] = null;
    }

    stateChanges['form'] = newForm;
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  getSchedules = data => {
    let schedules = [];

    if (data['day']) {
      schedules.push({
        day: data['day'],
        start_time: data['start_time'],
      });
    }
    return schedules;
  };

  handlePostAction = () => {
    const { actions, studentId } = this.props;
    const {
      slotPost: { id },
      form,
      formFields,
      teacher_id,
      studentCourses,
    } = this.state;

    const data = {};

    if (!teacher_id) {
      this.setState({
        errorText: 'Please select the teacher',
      });
      return;
    }

    if (!form.slotTag) {
      this.setState({ errorText: 'Slot Tag is mandatory' });
      return;
    }

    formFields.forEach(({ name, param }) => {
      if (name === 'startDate' || name === 'endDate') {
        data[param] = dateObjToEpoch(form[name]);
      } else if (name === 'startTime') data[param] = timeStringToEpoch(form[name]);
      else data[param] = form[name];
    });

    data['schedules'] = this.getSchedules(data);
    data['teacher_id'] = teacher_id;

    if (form.slotTag === 'TEST' && !form.studentCourse) {
      this.setState({ errorText: 'Student course is mandatory' });
      return;
    }
    if (form.studentCourse) {
      const selectedStudentCourse = studentCourses.filter(item => {
        return item.id === form.studentCourse;
      })[0];
      if (selectedStudentCourse) {
        data['student_course_id'] = selectedStudentCourse['id'];
        data['course_id'] = selectedStudentCourse['course_id'];
        data['course_stream'] = selectedStudentCourse['course_stream'];
        delete data['studentCourse'];
      }
    }
    trackEvent(EVENT_TYPE.CREATE_TEST_SLOT_SUBMIT_CLICK, {
      student_id: studentId,
      teacher_id,
    });

    actions.createDemoSlot(id, data, { studentId: studentId });
  };

  onSubmit = event => {
    const {
      slotPost: { current },
      type,
    } = this.state;

    event.preventDefault();
    if (type === FORM_ACTIONS.CREATE && !(current && current.isCreating))
      this.handlePostAction();
  };

  nextTab = () => {
    const { tab } = this.state;
    this.props.onNavigate({ tab: tab + 1 });
  };

  prevTab = e => {
    const { tab } = this.props;
    this.props.onNavigate({ tab: tab - 1 });
  };

  renderFormHeader = () => {
    return (
      <Head>
        <Text size="xlarge" align="center">
          Quick Slot Creation
        </Text>
      </Head>
    );
  };

  renderFormFields = () => {
    const { formFields, type, teachersData } = this.state;
    let choices = [];
    if (
      teachersData.data &&
      Array.isArray(teachersData.data) &&
      teachersData.data.length > 0
    ) {
      choices = teachersData.data.map(teacher => ({
        label: teacher.name + '-' + teacher.phone,
        value: teacher.id,
      }));
    }

    return (
      <FieldWrapper>
        <Field key="teachers">
          <Label>{'Teachers List'}</Label>
          <SelectInput
            name="teachers"
            onChange={this.onTeacherSelect}
            options={choices}
            onInputChange={debounce(
              (val, reason) => this.onTextChange(val, reason),
              1000,
            )}
          />
        </Field>
        {formFields.map(field => {
          const disabled =
            field.disabled ||
            type === FORM_ACTIONS.VIEW ||
            (!field.editable && type === FORM_ACTIONS.EDIT);
          const required = type === FORM_ACTIONS.CREATE ? field.required : false;
          const placeholder = disabled ? '' : field.label;

          return renderFormField({
            ...field,
            value: this.state.form[field.name],
            onChange: this[getInputChangeMethod(field)],
            required,
            disabled,
            placeholder,
          });
        })}
      </FieldWrapper>
    );
  };

  renderFormFooter = () => {
    const { type } = this.state;

    return (
      <Footer>
        <ButtonWrapper>
          <Button label="Create" disabled={type === FORM_ACTIONS.VIEW} />
        </ButtonWrapper>
      </Footer>
    );
  };

  render() {
    const { errorText, message } = this.state;
    return (
      <form onSubmit={this.onSubmit}>
        <FormWrapper>
          {this.renderFormHeader()}
          {message && <Message>{message}</Message>}
          <Separator transparent height="25" />
          {this.renderFormFields()}
          {errorText && <Message error={true}>{errorText}</Message>}
          <Separator transparent height="50" />
          {this.renderFormFooter()}
          <Separator transparent height="50" />
        </FormWrapper>
      </form>
    );
  }
}

export default connect(
  ({ demoSlots, configs, teacherList, studentCourses }) => ({
    demoSlots,
    teacherList,
    userConfig: store.get(configs, USER_CONFIG).data,
    batchConfig: store.get(configs, BATCHES_CONFIG).data,
    studentCourses,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        createDemoSlot,
        getTeacherList,
        invalidateStudentSlots,
        getAllStudentCourses,
      },
      dispatch,
    ),
  }),
)(CreateDemoSlot);
